import SxDef from '@core/types/SxDef';

const useSx = (isOpen: boolean): SxDef => ({
  paper: {
    display: isOpen ? 'flex' : 'none',
    position: 'fixed',
    top: '64px',
    right: '16px',
    zIndex: 1300,
    padding: '16px 24px',
    alignItems: 'center',
    gap: '24px',
  },
  loadingText: {
    '@keyframes fadein': {
      '0%': { opacity: 0.25 },
      '100%': { opacity: 1 },
    },
    animation: 'fadein 1s ease-in-out infinite alternate',
  },
});

export default useSx;
